import React, { Component } from 'react'

class PacerReceipt extends Component {
    render () {
        let pacerReceiptMarkup;
        const { pacerReceipt } = this.props;

        if (pacerReceipt) pacerReceiptMarkup = this.getPacerUpdateReceipt(pacerReceipt);

        return (
            <React.Fragment>
                { pacerReceiptMarkup }
            </React.Fragment>
        )
    }
    getPacerUpdateReceipt = (params) => {

        const { datetime, user_id, client_code, description, criteria, pages, cost } = params

        return (
            <div className='ir-search-receipt'>
                <table>
                    <thead>
                    <tr>
                        <th colSpan="2">PACER Service Center</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>Receipt:</th>
                        <td>{ datetime }</td>
                    </tr>
                    <tr>
                        <th>User:</th>
                        <td>{ user_id }</td>
                    </tr>
                    <tr>
                        <th>Client:</th>
                        <td>{ client_code }</td>
                    </tr>
                    <tr>
                        <th>Description:</th>
                        <td>{ description }</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td>{ criteria }</td>
                    </tr>
                    <tr>
                        <th>Pages:</th>
                        <td>{ pages }&nbsp;(${ cost })</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default PacerReceipt



// WEBPACK FOOTER //
// ./src/components/common/Receipt.js